"use client"

import Link from "next/link"
import { cn } from "@/lib/utils"

interface CenterHeaderAction {
  label: string
  href?: string
  onClick?: () => void
}

interface CenterHeaderProps {
  title: string
  action?: CenterHeaderAction
  showDivider?: boolean
  className?: string
}

/**
 * Shared header component for center column pages.
 * Renders: Title (left) + single text action (right) + optional subtle divider.
 */
export function CenterHeader({ title, action, showDivider = true, className }: CenterHeaderProps) {
  return (
    <div
      className={cn(
        "flex items-center justify-between gap-6 py-4",
        showDivider && "border-b border-white/5",
        className,
      )}
    >
      {/* Title - Playfair Display, truncate if too long */}
      <h1 className="min-w-0 truncate text-[30px] font-display font-normal text-foreground leading-[1.27]">{title}</h1>

      {/* Action - Inter text button */}
      {action &&
        (action.href ? (
          <Link
            href={action.href}
            className="shrink-0 text-sm font-sans font-medium text-muted-foreground hover:text-foreground transition-colors"
          >
            {action.label}
          </Link>
        ) : (
          <button
            onClick={action.onClick}
            className="shrink-0 text-sm font-sans font-medium text-muted-foreground hover:text-foreground transition-colors"
          >
            {action.label}
          </button>
        ))}
    </div>
  )
}
